import { render } from "./jin-pl35.vue?vue&type=template&id=1de624c1&scoped=true"
import script from "./jin-pl35.vue?vue&type=script&lang=js"
export * from "./jin-pl35.vue?vue&type=script&lang=js"

import "./jin-pl35.vue?vue&type=style&index=0&id=1de624c1&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de624c1"]])

export default __exports__